import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';


import { TokenStorageService } from '@/core/services/internal/token-storage.service';
import { SessionStorageService } from '@/core/services/internal/session-storage.service';
import { TokenVerificationService } from '@/core/services/internal/token-verification.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private tokenStorageService: TokenStorageService,
    private sessionStorageService: SessionStorageService,
    private tokenVerificationService: TokenVerificationService,
  ) {
  }

  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const currentUser = this.tokenStorageService.getUser();

    if (currentUser) {
      this.tokenVerificationService.setToken(currentUser?.session.accessToken);
      const isExpired = this.tokenVerificationService.isTokenExpired();
      if (isExpired !== null && !isExpired) {
        return true;
      }
    }

    this.sessionStorageService.clearStorage();
    await this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
